import Vue from "vue";
import VueI18n from "vue-i18n";
import store from "./store";
Vue.use(VueI18n);

let getDefaultLocationEN = () => {
  let defaultLocation = "";
  store.getters.getMaps.forEach((map) => {
    if (
      map.displayPosition.toString() === store.getters.getDefaultLocation &&
      map.locale === "en"
    ) {
      defaultLocation = map.mapName;
    }
  });
  return defaultLocation;
};

let getDefaultLocationES = () => {
  let defaultLocation = "";
  store.getters.getMaps.forEach((map) => {
    if (
      map.displayPosition.toString() === store.getters.getDefaultLocation &&
      map.locale === "es-US"
    ) {
      defaultLocation = map.mapName;
    }
  });
  return defaultLocation;
};
// The getters are to be called in the way below only when Map Datastructure is used.
let getHomepageEn = () => {
  return store.getters.getHomepage.filter((page) => page.locale === "en");
};

let getHomepageEs = () => {
  return store.getters.getHomepage.filter((page) => page.locale === "es-US");
};

let getFaqsEn = () => {
  return store.getters.getFaqs.filter((faq) => faq.locale === "en");
};

let getFaqsEs = () => {
  return store.getters.getFaqs.filter((faq) => faq.locale === "es-US");
};

let getFloorsEn = () => {
  return store.getters.getFloors.filter((floor) => floor.locale === "en");
};

let getFloorsEs = () => {
  return store.getters.getFloors.filter((floor) => floor.locale === "es-US");
};

// Getters for Maps -> English Language
let getMapsEn = () => {
  let temp = [];
  store.getters.getMaps.forEach((map) => {
    if (map.locale === "en") {
      temp.push(map);
    }
  });
  return temp;
};

let getMapsEs = () => {
  let temp = [];
  store.getters.getMaps.forEach((map) => {
    if (map.locale === "es-US") {
      temp.push(map);
    }
  });
  return temp;
};

let getFormCategoriesEn = () => {
  return store.getters.getFormCategories.filter(
    (category) => category.locale === "en"
  );
};

let getFormCategoriesEs = () => {
  return store.getters.getFormCategories.filter(
    (category) => category.locale === "es-US"
  );
};

let getQnaEn = () => {
  return store.getters.getQnaEndpointEN;
};
let getQnaEs = () => {
  return store.getters.getQnaEndpointES;
};

let getFormsEn = () => {
  let temp = [];
  store.getters.getForms.forEach((form) => {
    if (form.locale === "en") {
      temp.push(form);
    }
  });
  return temp;
};

let getFormsEs = () => {
  let temp = [];
  store.getters.getForms.forEach((form) => {
    if (form.locale === "es-US") {
      temp.push(form);
    }
  });
  return temp;
};

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
  messages: {
    en: {
      // Homepage
      homepages: getHomepageEn,

      // Faqs
      faqs: getFaqsEn,

      // Maps
      maps: getMapsEn,
      floors: getFloorsEn,

      // Forms
      formCategory: getFormCategoriesEn,
      forms: getFormsEn,

      qnaEndpoint: getQnaEn,

      defaultLocation: getDefaultLocationEN,

      kbError:
        "Sorry I'm still learning. Please ask me a different question or, get information about this topic at the following location.",
      defaultKBError:
        "Sorry, I'm not sure how to answer this question. Please ask me a different question, or you can continue using the touch interface. Also, you can get more information at the following location.",
      mapNotFound:
        "Sorry, I can't find the requested location, for more information please go to the following location.",
      formNotFound:
        "Sorry, I can't find the requested form, for more information please go to the following location.",
      selectOptionMsg:
        "Tap on the below, or click on the microphone to ask another question.",
      selectTrafficeOptionMsg:
        "Please select the option you prefer to pay fine.",
      noAnsOption1: "Go to " + getDefaultLocationEN,
      isThinking: "Thinking...",
      whatcanyoudo: "I have a hearing today?,What do I apply for protection order?,How do I pay my traffic ticket?,How do I obtain a passport?,How do I get my court records?"
    },
    es: {
      //Homepage
      homepages: getHomepageEs,
      // Faqs
      faqs: getFaqsEs,

      // Maps
      maps: getMapsEs,
      floors: getFloorsEs,

      // Forms
      formCategory: getFormCategoriesEs,
      forms: getFormsEn,

      qnaEndpoint: getQnaEs,
      defaultLocation: getDefaultLocationES,

      kbError:
        "Lo siento, aún estoy aprendiendo. Puede obtener información sobre este tema en el siguiente lugar.",
      defaultKBError:
        "Lo siento, no estoy seguro de cómo responder esta pregunta. Hágame una pregunta diferente o puede seguir usando la interfaz táctil. También puede obtener más información en el siguiente lugar.",
      mapNotFound:
        "Lo siento, no puedo encontrar el lugar solicitado. Para obtener más información, vaya al siguiente lugar.",
      formNotFound:
        "Lo siento, no puedo encontrar el formulario solicitado, vaya a la Biblioteca de Derecho para obtener más información.",
      selectOptionMsg:
        "Toque abajo o haga clic en el micrófono para hacer otra pregunta.",
      selectTrafficeOptionMsg:
        "Por favor, seleccione la opción que prefiera para pagar la multa.",
      noAnsOption1: "Go to " + getDefaultLocationEN,
      isThinking: "Pensando...",
      whatcanyoudo: "¿Tengo una audiencia hoy?,¿Dónde solicito una orden de protección?,¿Cómo pago mi multa de tráfico?,¿Cómo obtengo un pasaporte?,¿Cómo consigo mis registros judiciales?"
    },
  },
});
